import React from "react";
import { Flex } from "@chakra-ui/react";
import { withTranslation } from "react-i18next";
import BouncingDotsLoader from "src/components/BouncingDotsLoader";
import RoundButton from "../../RoundButton";
import { ReactComponent as FaceIcon } from "./face.svg";
import { ResponsiveCaption } from "../../ResponsiveCaption";

class SeeMeButton extends React.Component {
  state = {
    showBouncingDots: false
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.state !== this.props.state) {
      if (this.props.state === "starting") {
        this.loaderTimeoutId = setTimeout(
          () => this.setState({ showBouncingDots: true }),
          200
        );
      } else {
        clearTimeout(this.loaderTimeoutId);
        this.setState({ showBouncingDots: false });
      }
    }
  }

  componentWillUnmount() {
    clearInterval(this.loaderTimeoutId);
  }

  render() {
    const { showBouncingDots } = this.state;
    const { t, toggleSeeMe, state, tReady, ...rest } = this.props;
    return (
      <Flex flexDirection="column" alignItems="center" {...rest}>
        <RoundButton
          bg={state === "off" ? "black20" : "white"}
          height={["30px", "34px", "40px"]}
          icon={FaceIcon}
          iconFill={state === "off" ? "white" : "black54"}
          mb="0px"
          onClick={toggleSeeMe}
          showIconWithText={true}
          width={["67px", "80px", "86px"]}
          borderRadius="15px"
        >
          <ResponsiveCaption
            color={state === "off" ? "white" : "black38"}
            lineHeight="1.6"
            height={[`${1.6 * 10}px`, `${1.6 * 14}px`, `${1.6 * 16}px`]}
          >
            {showBouncingDots ? (
              <BouncingDotsLoader bg="primary" mt="8px" />
            ) : (
              t("buttons.face")
            )}
          </ResponsiveCaption>
        </RoundButton>
      </Flex>
    );
  }
}

export default withTranslation()(SeeMeButton);
